<template>
  <div class="form-signin-wrapper">
    <Loader v-if="loading"/>

    <div class="form-signin" v-else>
      <div class="mb-3 text-center">
        <img src="../assets/logo.png" height="25"/>
        <p>
          <small class="font-weight-bold text-primary">BETA</small>
        </p>
      </div>

      <div class="form-group">
        <input
          type="text"
          class="form-control form-control-lg"
          placeholder="Login"
          v-model="loginForm.login"/>
        <input
          type="password"
          class="form-control form-control-lg"
          placeholder="Password"
          v-model="loginForm.password"/>
      </div>

      <div class="form-group">
        <button
          type="submit"
          class="btn btn-primary btn-block btn-lg"
          @click="logIn">
          Sign In
        </button>
      </div>

      <div class="form-group">
        <p class="text-danger text-center font-weight-bold">{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from './common/Loader';

export default {
  name: 'Login',

  components: {Loader},

  data() {
    return {
      loginForm: {
        login: '',
        password: '',
      },
      error: '',
      loading: false,
    };
  },

  methods: {
    async logIn() {
      if (!this.loginForm.login) {
        this.error = 'Поле Login должно быть заполнено';

        return;
      }

      if (!this.loginForm.password) {
        this.error = 'Поле Password должно быть заполнено';

        return;
      }

      this.loading = true;

      try {
        await this.$store.dispatch('LOG_IN', this.loginForm);
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    }
  },
};
</script>
